import React, { Component } from 'react';
import _ from 'lodash';
import { inject, observer } from 'mobx-react';
import Notfication from './../../utils/notification-helper';
import StepContactList from './components/step-contact-list';
import SendEmail from '../../components/send-email-component';
import WorkflowStepBaseComponent from './workflow-step-base';
import moment from 'moment';
import { observable } from 'mobx';
import StepActionButtons from './components/step-actions';
import StepHistory from '../../components/step-history';
import StepSendEmail from './components/step-send-email';
import S3DownloadButton from '../../components/s3-download-button';

class SendInvoiceStore {
    @observable portalEmail;
    @observable attention;
    @observable selectedContact;
    @observable contacts = [];
}

@inject('appStore')
@observer
export default class SendInvoice extends WorkflowStepBaseComponent {
    constructor(props) {
        super(props);
        this.store = new SendInvoiceStore();
        this.renderIncompleteView.bind(this);
        this.additionalContacts = [];
        this.state = {invoiceData: {}, showEmail: false}
    }

    componentWillReceiveProps(props) {
        this.selectContactFromInvoice(props.invoiceStepState);
    }

    buildAgentContact() {
        const { selectedFile } = this.props.appStore.tcFileStore;
        return {
            contactType: 'Agent',
            contactTypeEnum: -1,
            contactTypeId: -1,
            companyName: selectedFile.agent.subscriberName,
            contactId: selectedFile.agent.agentContactId,
            transactionId: selectedFile.transactionId,
            ...selectedFile.agent.emailContact,
        };
    }

    selectContactFromInvoice(invoiceStepState) {
        if (invoiceStepState && invoiceStepState.isComplete && invoiceStepState.data.invoiceContact) {
            let firstName = invoiceStepState.data.invoiceContact.name
                    .split(' ')
                    .slice(0, -1)
                    .join(' '),
                lastName = invoiceStepState.data.invoiceContact.name
                    .split(' ')
                    .slice(-1)
                    .join(' ');
            if (invoiceStepState.data.invoiceContact.name.split(' ').length === 0) {
                firstName = invoiceStepState.data.invoiceContact.name;
                lastName = '';
            }
            const invoiceContact = {
                contactId: 1,
                contactType: 'Invoice',
                firstName: firstName,
                lastName: lastName,
                companyName: invoiceStepState.data.invoiceContact.companyName,
                email: invoiceStepState.data.invoiceContact.email,
            };
            this.additionalContacts = [invoiceContact];
            this.store.selectedContact = invoiceContact;
        }
    }

    componentDidMount() {
        if (this.props.appStore.tcFileStore.selectedFile.isTransaction) {
            this.props.appStore.transactionStore
                .getTransactionsById(this.props.appStore.tcFileStore.selectedFile.transactionId)
                .then(({ transaction }) => {
                    this.store.portalEmail = { email: transaction.PortalEmail, name: 'Property' };
                })
                .catch((err) => {
                    console.log(err);
                    Notfication.ToastError('Step failed to load');
                });
        } else {
            Notfication.ToastError('Step failed to load (expected file to be for a transaction)');
        }
        this.setState({invoiceData: this.props.invoiceStepState && this.props.invoiceStepState.data ? this.props.invoiceStepState.data : {}})
    }

    onChangeEvent(contact) {
        if (contact) {
            this.store.selectedContact = contact;
            this.setState({showEmail: true})
        }
    }

    onSent(emailModel) {
        const step = this.props.step;

        step.state.isComplete = true;
        step.state.data.selectedContact = this.store.selectedContact;
        step.state.data.model = emailModel;
        step.state.data.sentDate = moment().format();

        return this.updateStepState(step);
    }

    showEmail(value, evt) {
        evt.preventDefault();
        this.store.selectedContact = ""
        this.setState({ showEmail: value });
    }

    renderCompleteView(step) {
        return (
            <div>
                <StepSendEmail
                    model={step.state.data.model}
                    step={this.props.step}
                    sentDate={step.state.data.sentDate}
                    invoiceData={this.state.invoiceData}
                />
                <div className={'col-md-12'}>
                    <StepHistory
                        transitions={this.props.step.state.transitions ? this.props.step.state.transitions : []}
                        emails={this.props.step.state.data.emails ? this.props.step.state.data.emails : []}
                    />
                </div>
            </div>
        );
    }

    renderIncompleteView() {
        if (_.isEmpty(this.store.portalEmail)) {
            return null;
        } else {
            const agent = appStore.tcFileStore.selectedFile.agent,
                isNA = this.props.step.state.isMarkedNotApplicable;

            return (
                <div>
                    <StepActionButtons viewStore={this.viewStore} step={this.props.step} />
                    {isNA ? null : <hr className="section-header" />}
                    <StepContactList
                        isHidden={isNA}
                        defaultContacts={[this.buildAgentContact(), ...this.additionalContacts]}
                        selectedContactId={this.store.selectedContact ? this.store.selectedContact.contactId : -1}
                        onChangeEvent={this.onChangeEvent.bind(this)}
                    />
                    {!_.isEmpty(this.store.selectedContact) && this.state.showEmail ? (
                        <StepSendEmail
                            step={this.props.step}
                            updateStepState={this.updateStepState.bind(this)}
                            typeOfSale={this.props.appStore.tcFileStore.selectedFile.typeOfSale}
                            isHidden={isNA}
                            toEmails={[this.store.selectedContact]}
                            ccEmails={[this.store.portalEmail]}
                            template={'send-invoice'}
                            extraTemplateData={{ recipient: this.store.selectedContact.firstName, agent }}
                            onSent={this.onSent.bind(this)}
                            invoiceData={this.state.invoiceData}
                            cancelHandler={this.showEmail.bind(this, false)}
                            hasCancelHandler={this.props.hasCancelHandler}
                        />
                    ) : null}
                    <div className={'col-md-12'}>
                        <StepHistory
                            transitions={this.props.step.state.transitions ? this.props.step.state.transitions : []}
                            emails={this.props.step.state.data.emails ? this.props.step.state.data.emails : []}
                        />
                    </div>
                </div>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/workflow/steps/send-invoice.js